import type { ReactNode } from "react";
import { type IconName, LandingIcon } from "./LandingIcon";
import { CornerBracket } from "./LandingMark";

export function LandingChat() {
  return (
    <section
      id="method"
      className="relative z-10 overflow-hidden border-white/[0.06] border-b bg-brand-panel-alt px-6 py-24 md:px-12 md:py-32"
    >
      <CornerBracket position="br" size={16} />

      <div className="mx-auto max-w-4xl text-center">
        <h2 className="js-mask-reveal mb-6 font-medium text-3xl text-white tracking-tight md:text-5xl md:leading-[1]">
          Cada evento del campo, traducido en asiento contable.
        </h2>
        <p className="mx-auto mb-16 max-w-2xl text-base text-neutral-400 leading-relaxed md:text-lg">
          El productor registra el día a día desde el potrero. HATO acumula costos, deprecia el hato
          productivo y prepara el cierre contable del período.
        </p>

        <div className="scroll-fade relative mx-auto max-w-2xl rounded-3xl bg-gradient-to-b from-white/[0.1] to-transparent p-[1px]">
          <div className="relative flex flex-col gap-6 overflow-hidden rounded-[calc(1.5rem-1px)] bg-brand-panel p-6 text-left shadow-2xl md:p-10">
            <ChatMessage variant="system" icon="trending-up" title="Costo de crianza acumulado.">
              Reina (CR-103) suma ₡1.245.000 entre alimentación, sanidad y mano de obra desde su
              nacimiento.
            </ChatMessage>
            <ChatMessage variant="user">Registrar primer parto · Reina (CR-103).</ChatMessage>
            <ChatMessage variant="system" icon="file-check">
              Frontera contable cerrada. Crianza capitalizada a activo biológico productivo. Inicia
              depreciación lineal · 60 meses.
            </ChatMessage>

            <div
              aria-hidden
              className="-translate-x-1/2 pointer-events-none absolute bottom-[-40px] left-1/2 h-32 w-3/5"
              style={{
                background:
                  "radial-gradient(ellipse at center, rgba(0,229,153,0.1), transparent 60%)",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

type ChatMessageProps =
  | { variant: "user"; children: string; icon?: never; title?: never }
  | { variant: "system"; icon: IconName; title?: string; children: ReactNode };

function ChatMessage(props: ChatMessageProps) {
  if (props.variant === "user") {
    return (
      <div className="flex items-center gap-3 self-end rounded-2xl rounded-tr-sm bg-primary-500 p-3.5 font-medium text-brand-dark text-sm">
        <span>{props.children}</span>
        <LandingIcon name="check-read" size={16} className="opacity-80" />
      </div>
    );
  }
  return (
    <div className="flex max-w-[80%] items-start gap-4">
      <div className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-primary-500/30 bg-primary-500/10 text-primary-500">
        <LandingIcon name={props.icon} size={16} />
      </div>
      <div className="rounded-2xl rounded-tl-sm border border-white/[0.05] bg-white/[0.03] p-4">
        {props.title && <div className="mb-1 font-medium text-sm text-white">{props.title}</div>}
        <div
          className={`text-[13px] leading-[19px] ${props.title ? "text-neutral-400" : "text-white"}`}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
}
